<template>
    <slide-y-up-transition :delay="0" :duration="{enter:0, leave: 0}" mode="out-in" appear>
        <div class="headlineBackNavLinkWrapper" v-show="show">
            <button
                v-show="isShowArrows"
                :disabled="isFirst"
                class="headlineNavLink headlineNavLink-prev v-fade"
                @click.prevent="onPrevClick"
                ref="prev"
                title="Previous">
                <back-logo-prev-icon/>
            </button>

            <fade-transition :duration="{enter: 1000, leave: 10}" appear>
                <a
                    class="headlineBackLink"
                    title="Back"
                    ref="back"
                    @click.prevent="onBackClick"
                >
                    <back-logo-icon/>
                </a>
            </fade-transition>

            <button
                v-show="isShowArrows"
                :disabled="isLast"
                class="headlineNavLink headlineNavLink-next v-fade"
                @click.prevent="onNextClick"
                ref="next"
                title="Next">
                <back-logo-next-icon/>
            </button>
        </div>
    </slide-y-up-transition>
</template>

<script>
import {mapState} from 'vuex'
import {eventBus} from "../utils/shared";
import {mapGetters} from 'vuex'

export default {
    data() {
        return {
            show: true,
        }
    },
    created() {
        this.subscribe()
    },
    mounted() {
        this.onRoute()
    },
    watch: {
        '$route': 'onRoute'
    },
    computed: {
        ...mapGetters('player', [
            'current',
            'isFirst',
            'isLast',
            'prevLink',
            'nextLink',
        ]),
        ...mapState({
            back: state => state.player.back,
        }),
        ...mapGetters('ui', [
            'isMobile',
        ]),
        isShowArrows() {
            return this.isMobile && this.current;
        },
    },
    methods: {
        onRoute() {
            // if (this.isMobile) {
            //     return true;
            // }

            // this.show = [
            //     'featured-detail', 'editor-detail',
            // ].indexOf(this.$route.name) === -1;
            this.show = this.isMobile;
        },
        subscribe() {
            eventBus.$on('player.back', () => {
                this.go('back')
            })
            eventBus.$on('player.prev', () => {
                this.go('prev')
            })
            eventBus.$on('player.next', () => {
                if (this.isLast) {
                    this.$store.dispatch('player/setAutoplay', false)
                    eventBus.$emit('player.over')
                } else {
                    this.go('next')
                }
            })
        },
        go(direction) {
            //debugger
            if (['next', 'prev', 'back'].indexOf(direction) === -1) {
                return
            }

            this.$refs[direction].click()
        },
        onBackClick() {
            //debugger
            this.$router.push({path: this.back})
        },
        onPrevClick() {
            //debugger
            if (!this.isFirst) {
                this.$router.replace({path: this.prevLink})
                this.$store.dispatch('player/goPrev')
            }
        },
        onNextClick() {
            if (!this.isLast) {
                this.$router.replace({path: this.nextLink})
                this.$store.dispatch('player/goNext')
            }
        },
    }
}
</script>

<style>
.v-fade {
    display: inherit !important; /* override v-show display: none */
    transition: opacity 0.3s;
}

.v-fade[style*="display: none;"] {
    opacity: 0;
    pointer-events: none; /* disable user interaction */
    user-select: none; /* disable user selection */
}
</style>
